import { useAuth } from "@/lib/authContext";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="animate-spin text-[#3A2A10]" />
      </div>
    );
  }
  if (!user) {
    const redirectState = { from: location.pathname };
    return <Navigate to="/login" replace state={redirectState} />;
  }
  return children;
}
